import { Button } from "@mui/material";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

interface JoinSuccessModalProps {
  open: boolean;
  onClose: () => void;
  bookName: string;
  className: string;
  seatNo: string;
  onConfirm: () => void;
}

export const JoinSuccessModal: React.FC<JoinSuccessModalProps> = ({
  open,
  onClose,
  bookName,
  className,
  seatNo,
  onConfirm
}) => {
  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  if (!open) return null;

  return (
    <div
      onClick={onClose}
      className="fixed top-0 left-0 right-0 bottom-0 bg-black/50 flex items-center justify-center z-50 p-4"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="bg-white rounded-lg shadow-lg max-w-md w-full p-8 text-center"
      >
        <div className="mb-6">
          <CheckCircleIcon 
            sx={{ fontSize: 64, color: '#22c55e' }}
            className="mb-4"
          />
          <h2 className="text-2xl font-semibold text-gray-800 mb-2">
            加入成功
          </h2>
        </div>
        
        <div className="text-left bg-gray-50 rounded-lg p-4 mb-6">
          <div className="space-y-3">
            <div className="flex justify-between">
              <span className="text-gray-600">書籍名稱：</span>
              <span className="font-medium text-gray-800">{bookName}</span>
            </div>
            <div className="flex justify-between">
              <span className="text-gray-600">班級名稱：</span>
              <span className="font-medium text-gray-800">{className}</span>
            </div>
            <div className="flex justify-between">
              <span className="text-gray-600">我的座號：</span>
              <span className="font-medium text-gray-800">{seatNo}</span>
            </div>
          </div>
        </div>

        <Button
          onClick={handleConfirm}
          variant="contained"
          fullWidth
          sx={{
            bgcolor: '#1876d2',
            '&:hover': {
              bgcolor: '#1565c0'
            },
            fontSize: '16px',
            py: 1.5
          }}
        >
          確定
        </Button>
      </div>
    </div>
  );
};